export const myLesson = {
    "not_lesson_yet": "ຍັງບໍ່ມີບົດຮຽນເທື່ອ",
    "completed_prerequisite_lessons": "ທ່ານຍັງບໍ່ໄດ້ສຳເລັດບົດຮຽນທີ່ຈຳເປັນເທື່ອ. ໃຫ້ປະຕິບັດຕາມຂັ້ນຕອນບົດຮຽນກ່ອນ!",
};

